<template>
  <v-row>
    <v-col cols="2" offset="2">
      <v-btn block :loading="loading" @click="back">Wróć do szkolenia</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('courseExecution');

export default {
  data: function() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapActions(['getCourseToExecute']),
    async back() {
      this.loading = true;
      await this.getCourseToExecute({
        courseId: this.$route.params.courseId
      });
      await this.$router.push(`/course/${this.$route.params.courseId}`);
      this.loading = false;
    }
  }
};
</script>
